/**
 * Legacy-Redirect: /neighborhood → /hotspots
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/neighborhood')({
  beforeLoad: () => {
    throw redirect({ to: '/hotspots', replace: true })
  },
  component: () => null,
})
